import React, { useState } from 'react';
import PropTypes from 'prop-types';
import FormBase from '../../../../common/FormBase';
import { makeInitialState } from '../../../../../helpers/FormHelper';
import Form from './Form';
import { FIELDS } from './validation/fields';
import { schema } from './validation/schema';

const ArcoLawExercises = ({ ...props }) => {
  const { issueForm, mobile, motiveId, typeId } = props;
  const [state, setState] = useState({});
  const [data, setData] = useState({});
  const [valid, setValid] = useState(false);

  const handleData = (data) => {
    setData(data);
  };

  const onState = (innerState) => {
    setState(innerState);
  };

  const handleValid = (validity) => {
    setValid(validity);
  };

  return (
    <React.Fragment>
      <FormBase
        pre
        issueForm={issueForm}
        mobile={mobile}
        title=""
        form={
          <Form
            issueForm={issueForm}
            mobile={mobile}
            state={state}
            onData={handleData}
            valid={valid}
            motiveId={motiveId}
            typeId={typeId}
            fields={FIELDS}
          />
        }
        data={data}
        fields={FIELDS}
        formName="ArcoRights"
        makeInitialState={makeInitialState}
        onState={onState}
        onValid={handleValid}
        schema={schema}
        motiveId={motiveId}
        typeId={typeId}
      />
    </React.Fragment>
  );
};

ArcoLawExercises.propTypes = {
  mobile: PropTypes.bool,
  issueForm: PropTypes.bool,
  motiveId: PropTypes.string,
  typeId: PropTypes.string,
};

export default ArcoLawExercises;
